import template from './phoneAssign.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
controller: class controller {
    constructor($filter, $mdDialog, $mdMedia, eventService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.destroyWatch = eventService.onPhoneAssign((_params) => {
          $mdDialog
            .show({
              targetEvent: _params.event,
              locals: {
                phone: _params.phone,
                accounts: _params.accounts
              },
              template,
              controllerAs: '$ctrl',
              controller(phone, accounts) {
                const self = this;
                this.phone = phone;
                this.accounts = accounts;
                this.chips = accounts.map((account) => ({
                  id: account.id,
                  name: account.getName(),
                  email: account.user.eMail,
                  image: account.user.avatar
                }));
                this.chipsAssigned = $filter('filter')(this.chips, (c) =>
                  _.find(self.phone.owners, (o) => o.id === c.id)
                );
                this.chipsFilter = (query) =>
                  query
                    ? $filter('filter')(
                        self.chips,
                        (c) => c.name.toLowerCase().indexOf(query.toLowerCase()) > -1
                      )
                    : [];
                this.confirm = () => {
                  self.phone.owners = $filter('filter')(self.accounts, (a) =>
                    _.find(self.chipsAssigned, (c) => c.id === a.id)
                  );
                  $mdDialog.hide(self.phone);
                };
                this.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((phone) => {
              ctrl.onFinished({ phone: phone });
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
